import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  L10N_CONFIG,
  L10nConfig,
  L10nTranslationService
} from "angular-l10n";
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  constructor(
    private http: HttpClient,
    @Inject(L10N_CONFIG) private l10nConfig: L10nConfig,
    private translation: L10nTranslationService,
  ) { }

  init() {
    return new Promise<void>((resolve) => {
      // load default translation
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const url = `${this.l10nConfig.providers[0].asset}-${this.l10nConfig.defaultLocale.language}.json`;
      const options = {
        headers: headers,
        params: new HttpParams().set('v', this.l10nConfig.providers[0].options.version)
      };
      this.http.get(url, options).pipe(take(1))
        .subscribe(languageTranslations => {
          this.translation.data[this.l10nConfig.defaultLocale.language] = languageTranslations;
        });

      resolve();
    });
  }
}
